import { Icon } from '@pandiafi/design-system'
import React from 'react'

import { ScreenReaderHint } from '../ScreenReaderHint/ScreenReaderHint'

export interface UserMenuButtonProps {
  toggleUserMenu: () => void
  screenReaderHint: string
}

export const UserMenuButton = ({
  ref,
  toggleUserMenu,
  screenReaderHint,
}: UserMenuButtonProps & {
  ref?: React.RefObject<HTMLButtonElement | null>
}) => {
  return (
    <button
      ref={ref}
      type="button"
      className="rounded-md p-2 text-brand-6"
      onClick={toggleUserMenu}
    >
      <ScreenReaderHint hint={screenReaderHint} />
      <Icon
        icon="user-circle"
        size="2x"
        className="text-brand-6 w-9 fill-current"
      />
    </button>
  )
}
